module.exports = __webpack_public_path__ + "media/customizations/jordanranch/back-d5fe47818f6852c021fc2b6f11096b94.jpg";